import React from 'react';
import { Brain, FileText, MessageSquare, Mic } from 'lucide-react';

export function EmptyChat() {
  return (
    <div className="h-full flex items-center justify-center p-8">
      <div className="max-w-md bg-white rounded-xl shadow-sm p-8">
        <div className="relative mb-8">
          <div className="relative w-24 h-24 mx-auto">
            {/* Glow effect */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl opacity-75 blur-lg transform transition-all duration-200 group-hover:scale-110" />

            {/* Main icon */}
            <div className="relative w-24 h-24 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-[0_8px_16px_rgba(59,91,219,0.2)] transform transition-all duration-200 hover:scale-110 hover:shadow-[0_12px_24px_rgba(59,91,219,0.3)]">
              <Brain className="w-12 h-12 text-white" />
            </div>

            {/* Decorative icons */}
            <div className="absolute -top-2 -right-2 w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center transform rotate-12 shadow-sm">
              <Mic className="w-4 h-4 text-yellow-600" />
            </div>
            <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center transform -rotate-12 shadow-sm">
              <FileText className="w-4 h-4 text-green-600" />
            </div>
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">Start a Conversation</h2>

        <p className="text-gray-600 mb-6 text-lg leading-relaxed text-center">
          Ask questions and get intelligent responses, organized in a clean, card-based view.
        </p>

        <div className="space-y-4">
          <div className="flex items-center p-3 border border-gray-200 rounded-lg bg-gray-50">
            <MessageSquare className="flex-shrink-0 w-5 h-5 text-blue-500 mr-3" />
            <span className="text-gray-700">Type your questions to the AI assistant</span>
          </div>

          <div className="flex items-center p-3 border border-gray-200 rounded-lg bg-gray-50">
            <Mic className="flex-shrink-0 w-5 h-5 text-green-500 mr-3" />
            <span className="text-gray-700">Or just talk and our AI will respond</span>
          </div>

          <div className="flex items-center p-3 border border-gray-200 rounded-lg bg-gray-50">
            <FileText className="flex-shrink-0 w-5 h-5 text-purple-500 mr-3" />
            <span className="text-gray-700">Upload PDFs for context-aware answers</span>
          </div>
        </div>
      </div>
    </div>
  );
}
